export const FUNNEL_STAGES = [
  { id: "acquisition", label: "Aquisição" },
  { id: "capture", label: "Captura" },
  { id: "entry", label: "Entrada" },
  { id: "activation", label: "Ativação" },
  { id: "conversion", label: "Conversão" },
  { id: "expansion", label: "Expansão" },
  { id: "retention", label: "Retenção" },
];

export const TRANSVERSAL_STAGE = { id: "recovery", label: "Recuperação" };

export function getStageUxConfig(flowConfig, stageId) {
  const cfg = flowConfig && typeof flowConfig === "object" ? flowConfig : {};
  const ux = cfg.uxFunnel && typeof cfg.uxFunnel === "object" ? cfg.uxFunnel : {};
  const stages = ux.stages && typeof ux.stages === "object" ? ux.stages : {};
  const v = stages[stageId];
  return v && typeof v === "object" ? v : {};
}

export function isStageConfigured(flowConfig, stageId) {
  const ux = getStageUxConfig(flowConfig, stageId);
  if (Object.keys(ux).length) return true;

  // fallback (best-effort): se já existe grafo, consideramos “configurado” para não parecer tudo vazio
  const hasGraph = !!(flowConfig && typeof flowConfig === "object" && flowConfig.graph);
  return hasGraph;
}

